import { render } from "./LimitedPromotionPackageHeader.vue?vue&type=template&id=42237401&scoped=true"
import script from "./LimitedPromotionPackageHeader.vue?vue&type=script&lang=js"
export * from "./LimitedPromotionPackageHeader.vue?vue&type=script&lang=js"

import "./LimitedPromotionPackageHeader.vue?vue&type=style&index=0&id=42237401&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42237401"]])

export default __exports__